<template>
  <div class="home">
    <div class="grant2">
      <div class="grant_W">
        <div class="Applic">
          <div class="title">Thank you！</div>
          <div class="contents">
            The above information will be kept strictly confidential and used
            for internal reference only. <br/>Thank you very much for your support
            and trust in the TFSC.
          </div>
          <!-- <div class="botton" @click="goPage('/pc/Applicationb')">Start</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      swiperOption: {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 30,
        // setWrapperSize: true,
        mousewheel: true,
        autoHeight: true,
        height: window.innerHeight,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    goPage(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: #141414 !important;
  .grant2 {
    width: 100%;

    // height: 2670px;

    background: #141414 !important;
    .grant_W {
      width: 1320px;
      margin: 0 auto;
      display: flex;
      background: #141414;
      .Applic {
        width: 1320px;
        // border: 1px solid red;
        margin-top: 351px;
        background: #141414;
        // height: 1080px;
        .title {
          // margin-top: 333px;
          font-size: 60px;
          font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #cf61dc;
          text-align: center;
          margin-bottom: 20px;
        }
        .contents {
          //border: 1px solid red;

          margin: 0 auto;
          width: 1068px;
          font-size: 22px;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
          // margin-top: 48px;
          text-align: center;
          line-height: 40px;
          word-spacing: -2px;
        }
        .botton {
          width: 107px;
          height: 49px;
          background: #cf61dc;
          border-radius: 133px 133px 133px 133px;
          //opacity: 1;
          // width: 188px;
          // height: 85px;
          // background: #cf61dc;
          // border-radius: 133px 133px 133px 133px;
          opacity: 1;
          margin-top: 87px;
          text-align: center;
          font-size: 28px;
          font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
          font-weight: 700;
          color: #141414;
          line-height: 40px;
          margin-left: 566px;
          margin-bottom: 100px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
